import { z } from 'zod'
import { DeviceTypeEnum } from '../../data/enums'

export const GetLotIdsQuerySchema = z.object({
    __typename: z.literal('query_root').optional(),
    lot: z.array(
        z.object({
            __typename: z.literal('lot').optional(),
            id: z.string(),
            size: z.number().nullish(),
            address: z.string().nullish(),
            name: z.string().nullish()
        })
    )
})

export type GetLotIdsQuery = z.infer<typeof GetLotIdsQuerySchema>

export const GetStationByParkingLotQuerySchema = z.object({
    __typename: z.literal('query_root').optional(),
    station: z.array(
        z.object({
            __typename: z.literal('station').optional(),
            device_uuid: z.string().nullish(),
            station_name: z.string(),
            lot_section_id: z.string().nullish(),
            device_direction: z.string().nullish(),
            // Upstream codegen types this as `Scalars['json']` (i.e. `any`); kept loose to match.
            config: z.any().optional(),
            config_timestamp: z.string().nullish(),
            type: z.nativeEnum(DeviceTypeEnum).nullish(),
            enabled: z.boolean(),
            device: z
                .object({
                    __typename: z.literal('device').optional(),
                    uuid: z.string(),
                    config: z.any(),
                    config_target_timestamp: z.string().nullish(),
                    device_name: z.string().nullish()
                })
                .nullish()
        })
    )
})

export type GetStationByParkingLotQuery = z.infer<typeof GetStationByParkingLotQuerySchema>

export const OccupancyByLotIdResponseSchema = z.object({
    __typename: z.string().optional(),
    lot_id: z.string(),
    occupancy: z.number().nullish(),
    capacity: z.number().nullish(),
    occupancy_whitelist: z.number().nullish(),
    capacity_whitelist: z.number().nullish(),
    free_spaces: z.number().nullish(),
    traffic_light_status: z.string().nullish(),
    lot_healthy: z.number().nullish(),
    timestamp_lot_health_updated: z.string().nullish()
})

export type OccupancyByLotIdResponse = z.infer<typeof OccupancyByLotIdResponseSchema>

export const GetOccupancyByLotIdVariablesSchema = z.object({
    lot_ids: z.array(z.string())
})

export type GetOccupancyByLotIdVariables = z.infer<typeof GetOccupancyByLotIdVariablesSchema>

export const GetOccupancyByLotIdQuerySchema = z.array(OccupancyByLotIdResponseSchema)

export type GetOccupancyByLotIdQuery = z.infer<typeof GetOccupancyByLotIdQuerySchema>

export const GetScsDeviceCurrentValueVariablesSchema = z.object({
    device_space_id: z.string()
})

export type GetScsDeviceCurrentValueVariables = z.infer<typeof GetScsDeviceCurrentValueVariablesSchema>

export const GetScsDeviceCurrentValueQuerySchema = z.object({
    color: z.string().nullish(),
    content: z.string().nullish()
})

export type GetScsDeviceCurrentValueQuery = z.infer<typeof GetScsDeviceCurrentValueQuerySchema>
